<template lang="html"> 
   <!-- Principal -->
 <div class="datos-personales-fa" data-app>
    <titulo-seccion 
    :titulo="this.NombreCompletoProspecto"
    />
     <!-- Container -->
    <div class="container form-container">
      <stepper-movil
        :pasos="PasosStepper"
        :pasoActual="seccionActual"
      ></stepper-movil>
      <stepper :pasos="PasosStepper" :pasoActual="seccionActual"></stepper>
      <!-- Seccion 1-->
      <div ref="seccion-1" v-show="seccionActual == 1">
        <!-- Form 1 -->
        <form
          class="requiere-validacion"
          novalidate
          ref="formularioA"
          v-bind:class="{ 'was-validated': seccionValidadaA }"
        >
          <div class="row row-cols-lg-12 w-100 mt-3">
            <strong class="titulo-seccion">General Information</strong>
            <p class="parrafo-instrucciones mt-2">
              Enter your data correctly in each of the fields. Remember that you
              can use the help icon
              <i class="fas fa-question-circle icono-ayuda fa-lg"></i> for
               more details about how to fill it in.
            </p>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Given Name(s)"
                :requerido="true"
              ></etiqueta-campo>
              <input
                :disabled="soloLectura"
                maxlength="100"
                type="text"
                placeholder="Given Name(s) *"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.nombres"
                required
              />
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Middle name"
              ></etiqueta-campo>
              <input
                :disabled="soloLectura"
                maxlength="100"
                type="text"
                placeholder="Middle name"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.apellidoMaterno"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo texto="Surname or family name"
              :requerido="true"
              ></etiqueta-campo>
              <input
                :disabled="soloLectura"
                maxlength="100"
                placeholder="Surname or family name"
                type="text"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.apellidoPaterno"
                required
              />
            </div>
            <div
              class="col-lg-6 columna--campos"
              v-if="PuntoContactoGeneral.telefonoMovil.valor != null"
            >
              <etiqueta-campo texto="Mobile phone"
              :requerido="true"></etiqueta-campo>
              <input
                :disabled="this.soloLectura"
                type="number"
                onkeydown="return event.KeyCode !== 69"
                min="0"
                placeholder="Mobile phone (10 digits) *"
                class="form-control campo-basico"
                v-model="PuntoContactoGeneral.telefonoMovil.valor"
                required
              />
            </div>
            <div class="col-lg-6 columna--campos" v-else>
              <etiqueta-campo
                texto="Mobile phone"
                :requerido="true"
              ></etiqueta-campo>
              <input
              :disabled="this.soloLectura"
                type="number"
                onkeydown="return event.KeyCode !== 69"
                min="0"
                placeholder="Mobile phone (10 digits) *"
                class="form-control campo-basico"
                v-model="PuntoContactoGeneral.telefonoMovil.valor"
                required
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div
              class="col-lg-6 columna--campos"
              v-if="PuntoContactoGeneral.correo1.valor != null"
            >
              <etiqueta-campo texto="Email"
              :requerido="true"
              ></etiqueta-campo>
              <input
                disabled
                type="email"
                placeholder="Ej. name@mail.com *"
                class="form-control campo-basico campo-minuscula"
                v-model="PuntoContactoGeneral.correo1.valor"
                required
              />
            </div>
            <div class="col-lg-6 columna--campos" v-else>
              <etiqueta-campo
                texto="Email"
                :requerido="true"
              ></etiqueta-campo>
              <span style="display: flex; align-items: center">
                <input
                  type="email"
                  placeholder="Ej. name@mail.com *"
                  class="form-control campo-basico campo-minuscula"
                  v-model="PuntoContactoGeneral.correo1.valor"
                  required
                />
              </span>
            </div>
            <div class="col-lg-6 columna--campos" style="text-align: left">
              <etiqueta-campo
                texto="Date of birth"
                :requerido="true"
              ></etiqueta-campo>
              <input-fecha
                :deshabilitado="soloLectura"
                idioma="en-US"
                v-model="personaFisicaFiguraAdicional.fechaNacimiento"
                :fechaMaxima="new Date().toISOString()"
              ></input-fecha>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Date of birth is required
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-12" style="align-items: center">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo texto="Gender" :requerido="true"></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Gender *"
                :arreglo="this.catalogos.sexos"
                llave="value"
                valor="value"
                texto="text"
                v-model="personaFisicaFiguraAdicional.sexo"
                :requerido="true"
              ></DropDown>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Gender is required
              </div>
            </div>
          </div>

          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Nationality"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Select a nationality *"
                :arreglo="this.catalogos.paises"
                llave="paisId"
                valor="paisId"
                texto="gentilicioIngles"
                v-model="personaFisicaFiguraAdicional.nacionalidad"
                :requerido="true"
              ></DropDown>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Nationality is required
              </div>
            </div>
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Place of birth"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Select a place of birth *"
                :arreglo="this.catalogos.paises"
                llave="paisId"
                valor="paisId"
                texto="descripcionIngles"
                v-model="personaFisicaFiguraAdicional.lugarNacimiento"
                :requerido="true"
              ></DropDown>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Place of birth is required
              </div>
            </div>
          </div>

          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo
                texto="ID type"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Select a ID type *"
                :arreglo="this.catalogos.tiposIdentificacion"
                llave="value"
                valor="value"
                texto="text"
                v-model="personaFisicaFiguraAdicional.tipoIdentificacion"
                :requerido="true"
              ></DropDown>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                ID type is required
              </div>
            </div>
            <div class="col-lg-6">
              <etiqueta-campo texto="Passport number"
              :requerido="true"
              ></etiqueta-campo>
              <input
                :disabled="this.soloLectura"
                placeholder="Passport number *"
                type="text"
                class="form-control campo-basico"
                required
                v-model="personaFisicaFiguraAdicional.numeroIdentificacion"
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Passport number is required
              </div>
            </div>
          </div>

          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Marital estatus"
                :requerido="true"
              ></etiqueta-campo>
              <drop-down
                :disabled="soloLectura"
                placeholder="Select a marital estatus *"
                :arreglo="catalogos.estadosCiviles"
                llave="value"
                valor="value"
                texto="text"
                v-model="personaFisicaFiguraAdicional.estadoCivil"
                :requerido="true"
              ></drop-down>
            </div>
            <div
              class="col-lg-6 columna--campos"
              v-if="personaFisicaFiguraAdicional.estadoCivil == 1"
            >
              <etiqueta-campo
                texto="Financial marriage rules"
                :requerido="true"
              ></etiqueta-campo>
              <drop-down
                :disabled="soloLectura"
                placeholder="Select a financial marriage rules *"
                :arreglo="catalogos.regimenesMatrimoniales"
                llave="value"
                valor="value"
                texto="text"
                v-model="personaFisicaFiguraAdicional.regimenMatrimonial"
                :requerido="true"
              ></drop-down>
            </div>
          </div>
          <div
            v-if="personaFisicaFiguraAdicional.estadoCivil == 1"
            class="row row-cols-lg-12">
            <div class="row row-cols-lg-12">
              <div class="col-lg-6 columna-campos">
                <etiqueta-campo
                  texto="Spouse's full name"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  :disabled="soloLectura"
                  maxlength="100"
                  type="text"
                  placeholder="Spouse's full name *"
                  class="form-control campo-basico"
                  v-model="personaFisicaFiguraAdicional.nombreConyuge"
                  required
                />
              </div>
              <div class="col-lg-6 columna-campos">
                <etiqueta-campo
                  texto="Spouse's home phone"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  placeholder="Spouse's home phone (10 digits)"
                  :disabled="this.soloLectura"
                  type="number"
                  onkeydown="return event.KeyCode !== 69"
                  min="0"
                  class="form-control campo-basico"
                  v-model="PuntoContactoConyuge.telefonoFijoConyuge.valor"
                  required
                />
              </div>
              <div class="col-lg-6 columna-campos">
                <etiqueta-campo
                  texto="Spouse's cell phone"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  :disabled="this.soloLectura"
                  type="number"
                  onkeydown="return event.KeyCode !== 69"
                  min="0"
                  placeholder="Spouse's cell phone (10 digits) *"
                  class="form-control campo-basico"
                  v-model="PuntoContactoConyuge.telefonoMovilConyuge.valor"
                  required
                />
              </div>
              <div class="col-lg-6 columna-campos">
                <etiqueta-campo
                  texto="Spouse's email address"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  :disabled="this.soloLectura"
                  type="email"
                  placeholder="Spouse email (e.g. name@email.com) *"
                  class="form-control campo-basico campo-minuscula"
                  v-model="PuntoContactoConyuge.correoConyuge.valor"
                  required
                />
              </div>
            </div>
          </div>
          <div class="col-12 mt-3">
            <button
              ref="submitA"
              @click.prevent="ValidarFormularioAntesAvanzar"
              class="btn btn-primary"
              hidden
              type="submit"
            >
              Submit form
            </button>
          </div>
        </form>
        <!-- Form 1-->
      </div>
      <!-- Seccion 1-->

      <!-- Seccion 2-->
      <div ref="seccion-2" v-show="seccionActual == 2">
        <!-- Form 2-->
        <form
          class="requiere-validacion"
          novalidate
          ref="formularioB"
          v-bind:class="{ 'was-validated': seccionValidadaB }"
        >
          <div class="row row-cols-lg-12 w-100 mt-3">
            <strong class="titulo-seccion">Address</strong>
            <p class="parrafo-instrucciones mt-2">
              Enter your current address information correctly.
            </p>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-5 columna--campos">
              <etiqueta-campo texto="Street" :requerido="true"></etiqueta-campo>
              <input
                maxlength="255"
                :disabled="this.soloLectura"
                placeholder="Street *"
                type="text"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.calle"
                required
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Street is required.
              </div>
            </div>
            <div class="col-lg-3 columna--campos">
              <etiqueta-campo texto="Number" :requerido="true"></etiqueta-campo>
              <input
                maxlength="20"
                :disabled="this.soloLectura"
                placeholder="Number *"
                type="text"
                min="0"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.numero"
                required
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Number is required.
              </div>
            </div>
            <div class="col-lg-4 columna--campos">
              <etiqueta-campo
                texto="Zip Code"
                :requerido="true"
              ></etiqueta-campo>
              <input
                :disabled="soloLectura"
                placeholder="Zip Code *"
                type="text"
                required
                min="0"                
                class="form-control campo-basico"
                v-model="codigoPostalParticular"
                pattern="^[ A-Za-z0-9_@./#&+-]{1,10}$"
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Zip Code is required.
              </div>
            </div>
          </div>

          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Suburb/Town"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Suburb/Town *"
                :disabled="this.soloLectura"
                v-model="DatosUbicacionParticular.ciudad"
                pattern="[A-Za-z\s]{4,}"
                type="text"
                class="form-control campo-basico"
                required
              />
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo texto="State" :requerido="true"></etiqueta-campo>
              <input
                placeholder="State *"
                :disabled="this.soloLectura"
                v-model="DatosUbicacionParticular.estado"
                type="text"
                class="form-control campo-basico"
                pattern="[A-Za-z\s]{4,}"
                required
              />
            </div>
          </div>

          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Country"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Country *"
                :arreglo="this.catalogos.paises"
                llave="paisId"
                valor="paisId"
                texto="descripcionIngles"
                v-model="DatosUbicacionParticular.paisId"
                :requerido="true"
              ></DropDown>
            </div>
          </div>
          <div class="col-12">
            <button
              ref="submitB"
              @click.prevent="ValidarFormularioAntesAvanzar"
              class="btn btn-primary"
              hidden
              type="submit"
            >
              Submit form
            </button>
          </div>
        </form>
        <!-- Form 2 -->
      </div>
      <!-- Seccion 2 -->
      <!-- Seccion 3 -->
      <div ref="seccion-3" v-show="seccionActual == 3">
        <!-- Form 3 -->
        <form
          class="requiere-validacion"
          novalidate
          ref="formularioC"
          v-bind:class="{ 'was-validated': seccionValidadaC }"
        >
          <div class="row row-cols-lg-12 w-100 mt-3">
            <strong class="titulo-seccion">Income Profile</strong>
            <p class="parrafo-instrucciones mt-2">
              Enter your income data correctly.
            </p>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Occupation"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                :requerido="true"
                placeholder="Select a occupation *"
                :arreglo="this.catalogos.profesiones"
                llave="profesionId"
                valor="profesionId"
                texto="descripcionIngles"
                v-model="personaFisicaFiguraAdicional.profesion"
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Academic degree"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                :requerido="true"
                placeholder="Select a academic degree *"
                :arreglo="this.catalogos.gradosEstudio"
                llave="value"
                valor="value"
                texto="text"
                v-model="personaFisicaFiguraAdicional.gradoEstudios"
              ></DropDown>
            </div>
          </div>

          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo texto="Number of dependents"></etiqueta-campo>
              <input
                :disabled="this.soloLectura"
                placeholder="Number of dependents"
                type="number"
                onkeydown="return event.KeyCode !== 69"
                min="0"
                max="10"
                maxlength="2"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.numeroDependientes"
              />
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Currency of your income/expenditure"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                :requerido="true"
                invalidFeedback="The currency is required."
                placeholder="Select the currency of your income/expenditure. *"
                :arreglo="this.catalogos.divisas"
                llave="value"
                valor="value"
                texto="text"
                v-model="personaFisicaFiguraAdicional.divisa"
              ></DropDown>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Monthly income"
                :requerido="true"
              ></etiqueta-campo>
              <VueAutonumeric
                :disabled="this.soloLectura"
                class="form-control campo-basico"
                :options="opcionesAutoNumeric"
                :placeholder="'Monthly Income *'"
                v-model="personaFisicaFiguraAdicional.monto"
                required
              ></VueAutonumeric>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Monthly expenditure"
                :requerido="true"
              ></etiqueta-campo>
              <VueAutonumeric
                :disabled="this.soloLectura"
                class="form-control campo-basico"
                :options="opcionesAutoNumeric"
                :placeholder="'Monthly expenditure *'"
                v-model="personaFisicaFiguraAdicional.egresoMensual"
                required
              ></VueAutonumeric>
            </div>
          </div>

          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Type of housing"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                :requerido="true"
                placeholder="Select a type of housing *"
                :arreglo="this.catalogos.tiposVivienda"
                llave="value"
                valor="value"
                texto="text"
                v-model="personaFisicaFiguraAdicional.tipoVivienda"
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Comercial activity"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Select a comercial activity *"
                :arreglo="this.catalogos.tiposEmpleo"
                llave="value"
                valor="value"
                texto="text"
                v-model="personaFisicaFiguraAdicional.tipoEmpleo"
                :requerido="true"
              ></DropDown>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo
                texto="Type of income"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Select a type of income *"
                invalidFeedback="You must select the type of income you receive"
                :arreglo="this.catalogos.tiposIngreso"
                llave="value"
                valor="value"
                texto="text"
                v-model="personaFisicaFiguraAdicional.tipoIngreso"
                :requerido="true"
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo texto="Company name"></etiqueta-campo>
              <input
                placeholder="Company name"
                :disabled="this.soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.empresa"
              />
            </div>
          </div>



          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo texto="Current position"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Current position"
                invalidFeedback="You must choose a position"
                :arreglo="this.catalogos.puestos"
                llave="puestoId"
                valor="puestoId"
                texto="puestoIngles"
                v-model="personaFisicaFiguraAdicional.puestoId"
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo texto="Seniority (years)"></etiqueta-campo>
              <input
                placeholder="Seniority (years)"
                :disabled="this.soloLectura"
                type="number"
                onkeydown="return event.KeyCode !== 69"
                min="0"
                max="65"
                maxlength="2"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.antiguedadAnios"
              />
            </div>
          </div>
          

          
          <!-- <div class="row row-cols-lg-12">
            <div
              class="col-lg-6 columna--campos"
              hidden
              v-if="personaFisicaFiguraAdicional.puestoId != 19"
            >
              <etiqueta-campo
                texto="Current position"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Current position"
                :disabled="this.soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.otroPuesto"
              />
            </div>
            <div class="col-lg-6 columna--campos" v-else>
              <etiqueta-campo
                texto="Current position"
                :requerido="true"
              ></etiqueta-campo>
               <input
                placeholder="Current position"
                :disabled="this.soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.otroPuesto"
              />
            </div>
          </div> -->
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo texto="Department"></etiqueta-campo>
              <input
                maxlength="64"
                placeholder="Department"
                :disabled="this.soloLectura"
                type="texto"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.departamentoEmpleo"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo texto="Company line of business"
              ></etiqueta-campo>
               <DropDown
               :disabled="this.soloLectura"
                placeholder="Company's line of business"
                :arreglo="this.catalogos.giros"
                llave="giroId"
                valor="giroId"
                texto="giroIngles"
                v-model="personaFisicaFiguraAdicional.giroEmpresaId"
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo texto="Company address (Street)"></etiqueta-campo>
              <input
                placeholder="Company address (Street)"
                :disabled="this.soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.calleOficina"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo texto="Company address (Number)"></etiqueta-campo>
              <input
                maxlength="20"
                placeholder="Company address (Number)"
                :disabled="this.soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="personaFisicaFiguraAdicional.numeroOficina"
              />
            </div>
            <div class="col-lg-6">
              <etiqueta-campo texto="Zip Code"></etiqueta-campo>
              <input
                placeholder="Zip Code"
                :disabled="this.soloLectura"
                type="text"
                min="0"
                class="form-control campo-basico"
                v-model="codigoPostalOficina"
                pattern="^[ A-Za-z0-9_@./#&+-]{1,10}$"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Company address (Suburb/Town)"
              ></etiqueta-campo>
              <input
                placeholder="Suburb/Town"
                :disabled="this.soloLectura"
                v-model="DatosUbicacionOficina.ciudad"
                type="text"
                class="form-control campo-basico"
              />
            </div>
            <div class="col-lg-6">
              <etiqueta-campo texto="Company address (State)"></etiqueta-campo>
              <input
                placeholder="State"
                :disabled="this.soloLectura"
                v-model="DatosUbicacionOficina.estado"
                type="text"
                class="form-control campo-basico"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Company address (Country)"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Select a country"
                :arreglo="this.catalogos.paises"
                llave="paisId"
                valor="paisId"
                texto="descripcionIngles"
                v-model="DatosUbicacionOficina.paisId"
              ></DropDown>
            </div>
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo texto="Phone"></etiqueta-campo>
              <input
                placeholder="Phone (10 Digits)"
                :disabled="this.soloLectura"
                type="number"
                onkeydown="return event.KeyCode !== 69"
                min="0"
                class="form-control campo-basico"
                v-model="PuntoContactoGeneral.telefonoFijoOficina.valor"
              />
            </div>
          </div>

          <div class="row row-cols-lg-12">
            <div class="col-lg-6 columna--campos">
              <etiqueta-campo texto="Office E-mail"></etiqueta-campo>
              <input
                :disabled="this.soloLectura"
                type="email"
                placeholder="e.g., person@company.com"
                class="form-control campo-basico campo-minuscula"
                v-model="PuntoContactoGeneral.correo2.valor"
              />
            </div>
          </div>
          <div class="col-12">
            <button
              ref="submitC"
              @click.prevent="ValidarFormularioAntesAvanzar"
              class="btn btn-primary"
              hidden
              type="submit"
            >
              Submit form
            </button>
          </div>
        </form>
        <!-- Form 3 -->
      </div>
      <!-- Seccion 3 -->
      <!-- Seccion 4 -->
      <div ref="seccion-4" v-show="seccionActual == 4">
        <div class="row row-cols-lg-12 w-100 mt-3">
          <strong class="titulo-seccion">Beneficiaries</strong>
          <p class="parrafo-instrucciones mt-2">
            Enter your beneficiaries data correctly
          </p>
        </div>
        <!-- Form 4 -->
        <div
          v-for="(formBeneficiario, index) in FormBeneficiarios"
          v-bind:key="index"
        >
          <form class="mt-3" novalidate>
            <div class="row row-cols-lg-12">
              <div class="col-lg-6 columna--campos">
                <etiqueta-campo
                  texto="Given name(s)"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  :disabled="soloLectura"
                  type="text"
                  placeholder="Given Name(s) *"
                  class="form-control campo-basico"
                  v-model="formBeneficiario.nombre"
                  required
                />
              </div>
              <div class="col-lg-6 columna--campos">
                <etiqueta-campo
                  texto="Middle name"
                ></etiqueta-campo>
                <input
                  :disabled="soloLectura"
                  type="text"
                  placeholder="Middle name "
                  v-model="formBeneficiario.apellidoMaterno"
                  class="form-control campo-basico"
                />
              </div>
            </div>
            <div class="row row-cols-lg-12 row-ap-materno-benfeficiario">
              <div class="col-lg-6 columna--campos">
                <etiqueta-campo texto="Surname or family name" :requerido="true"></etiqueta-campo>
                <input
                  :disabled="soloLectura"
                  type="text"
                  placeholder="Surname or family name *"
                  v-model="formBeneficiario.apellidoPaterno"
                  class="form-control campo-basico"
                   required
                />
              </div>
              <div class="col-lg-6 columna--campos">
                <etiqueta-campo
                  texto="Type of relationship"
                  :requerido="true"
                ></etiqueta-campo>
                <DropDown
                  :disabled="soloLectura"
                  placeholder="Type of relationship *"
                  :arreglo="catalogos.parentescos"
                  llave="value"
                  valor="value"
                  texto="text"
                  v-model="formBeneficiario.parentesco"
                  :requerido="true"
                ></DropDown>
              </div>
            </div>

            <div class="row row-cols-lg-12 row-ap-materno-benfeficiario">
              <div class="col-lg-6 columna--campos">
                <etiqueta-campo
                  texto="Percentage"
                  :requerido="true"
                ></etiqueta-campo>
                <div class="input-group">
                  <input
                    :disabled="soloLectura"
                    @keyup="LimitarPorcentaje(index)"
                    type="number *"
                    onkeydown="return event.KeyCode !== 69"
                    min="0"
                    class="form-control campo-basico"
                    v-model="formBeneficiario.porcentaje"
                    placeholder="e.g., 70"
                    required
                  />
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text"
                      style="
                        border-radius: 0px;
                        border: 1px solid;
                        font-family: 'Poppins';
                      "
                      >%</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-lg-6 columna--campos">
                <etiqueta-campo
                  texto="Phone"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  :disabled="soloLectura"
                  type="number"
                  onkeydown="return event.KeyCode !== 69"
                  min="0"
                  placeholder="Phone (10 dígits) *"
                  v-model="formBeneficiario.telefono"
                  class="form-control campo-basico"
                  required
                />
              </div>
            </div>
            <div
              class="col-lg-12 col-sm-12"
              style="text-align: end"
              v-if="soloLectura == false"
            >
              <strong
                v-if="FormBeneficiarios.length > 1"
                class="etiqueta-nuevo-documento"
                @click.prevent="EliminarBeneficiarioTest(index)"
                >Delete beneficiarie</strong
              >
            </div>
            <div
              class="col-lg-12 col-sm-12 col-agregar-beneficiario"
              style="text-align: end"
            >
              <label
                v-if="soloLectura == false"
                class="etiqueta-nuevo-documento"
                @click.prevent="AgregarFormBeneficiario(true)"
                >Add another beneficiarie</label
              >
            </div>
          </form>
        </div>
        <!-- Form 4 -->
      </div>
      <!-- Seccion 4 -->

      <!-- Botones -->
      <div
        class="row row-cols-lg-12 mt-2 mb-2 columna-botones"
        style="justify-content: flex-end"
      >
        <button
          type="button"
          class="boton-transparente boton-seccion-anterior"
          @click.prevent="AnteriorSeccion()"
          v-if="seccionActual != 1"
        >
          Previous
        </button>
        <button
          type="button"
          class="boton-primario boton-siguiente-seccion"
          v-if="MostrarBotonFinalizar"
          @click.prevent="GuardarDatosPersonales()"
        >
          Complete
        </button>
        <button
          type="button"
          class="boton-primario boton-siguiente-seccion"
          @click.prevent="SiguienteSeccion()"
          v-else
        >
          Next
        </button>
      </div>
      <!-- Botones -->
    </div>
    <!-- Container -->
  </div>
  <!-- Principal -->
</template>

<script>
//Rutas API
const rutaCargarDatosExistentesFiguraAdicional =
  "/api/Master/FiguraAdicional/ObtenerDatosExistentesFiguraAdicionalExtranjero";
const rutaGuardarPersonaFisicaFiguraAdicional =
  "/api/Master/FiguraAdicional/GuardarPersonaFisicaFiguraAdicionalExtranjero";
const rutaObtenerFiguraAdicionalId =
  "/api/Master/FiguraAdicional/ObtenerFiguraAdicionalId";

//Plugins
import axios from "axios";
//Componentes
import TituloSeccion from "../../../Componentes/TituloSeccion.vue";
import Stepper from "../components/Stepper.vue";
import StepperMovil from "../components/StepperMovil.vue";
import InputFecha from "../components/InputFecha.vue";
import DropDown from "../components/DropDown.vue";
import VueAutonumeric from "../../../../../../node_modules/vue-autonumeric/src/components/VueAutonumeric.vue";
//Mixins
import mixinSolicitudInscripcion from "../Mixins/MixinSolicitudInscripcion";
//Servicios
import servicios from "../../../servicios/service.js";

export default {
  name: "DatosPersonalesFiguraAdicionalex",
  components: {
    TituloSeccion,
    Stepper,
    StepperMovil,
    InputFecha,
    DropDown,
    VueAutonumeric
  },
  mixins: [mixinSolicitudInscripcion],
  async mounted() {
    this.ProspectoId = this.$store.getters.prospectoId;
    this.tipoPersona = await this.ObtenerTipoPersona(this.ProspectoId);
    //Carga de catalogos
    await this.CargarSexos(true);
    await this.CargarTiposIdentificacion(true);
    await this.CargarProfesiones(true);
    await this.CargarTiposVivienda(true);
    await this.CargarTiposIngreso(true);
    await this.CargarGradosEstudio(true);
    await this.CargarDivisas(true);
    await this.CargarTiposEmpleo(true);
    await this.CargarEstadosCiviles(true);
    await this.CargarRegimenesMatrimoniales(true);
    await this.CargarParentescos(true);
    //Exclusivo Extranjero
    await this.CargarPaises(true);
    await this.CargarMediosPago(true);
    await this.CargarPuestos(true);
    await this.CargarGiros(true);
    await this.CargarRegimenesFiscales(true, false);

    //Carga de información existente
    await this.ObtenerFiguraAdicionalId();
    await this.CargarDatosExistentesFiguraAdicional(this.ProspectoId);
    await this.ConsultarBeneficiariosTest();

    this.tipoUsuario = this.$store.getters.tipoUsuario;

    this.NombreCompletoProspecto = "PERSONAL DATA: " + this.personaFisicaFiguraAdicional.nombres + " " + this.personaFisicaFiguraAdicional.apellidoMaterno + " " + this.personaFisicaFiguraAdicional.apellidoPaterno;

    if(this.personaFisicaFiguraAdicional.etapaId > 5) this.soloLectura = true;
    if(this.personaFisicaFiguraAdicional.etapaId > 4)
    {
     this.seccionActual = 1;
    }

      if (this.tipoUsuario != 3) {
              this.seccionActual = 1;
            }
  },
  data() {
    return {
      NombreCompletoProspecto: "",
      ProspectoId: null,
      tipoPersona: null,
      solicitudExistenteId: null,
      seccionActual: 1,
      soloLectura: false,
      tipoUsuario: null,
      tipoFiguraAdicional: null,
      //Catalogos
      catalogos: {
        sexos: [],
        tiposIdentificacion: [],
        estadosCiviles: [],
        regimenesMatrimoniales: [],
        colonias: [],
        parentescos: [],
        coloniasEmpresa: [],
        coloniasFactura: [],
        profesiones: [],
        tiposVivienda: [],
        gradosEstudio: [],
        divisas: [],
        tiposEmpleo: [],
        tiposIngreso: [],
        tiposEnvio: [],
        mediosPago: [],
        giros: [],
        puestos: [],
        regimenesFiscales: [],
        direccionesFacturacion: [
          {
            text: "Misma que domicilio personal",
            value: "0",
          },
          {
            text: "Otra",
            value: "1",
          },
        ],
      },
      CPExpresionRegularPais: "",
      opcionesAutoNumeric: {
        digitGroupSeparator: ",",
        decimalCharacter: ".",
        decimalCharacterAlternative: ".",
        currencySymbol: "$",
        currencySymbolPlacement: "p",
        roundingMethod: "U",
        minimumValue: "0",
        maximumValue: "15000000",
      },

      //Validaciones
      seccionValidadaA: false,
      seccionValidadaB: false,
      seccionValidadaC: false,
      esMayorDeEdad: false,
      //Modelos
      personaFisicaFiguraAdicional: {
        solicitudId: 0,
        personaFisicaFiguraAdicionalId: 0,
        figuraAdicionalId: 0,
        nombres: null,
        apellidoPaterno: null,
        apellidoMaterno: null,
        fechaNacimiento: null,
        sexo: null,
        rfc: null,
        curp: null,
        lugarNacimiento: null,
        nacionalidad: null,
        tipoIdentificacion: null,
        numeroIdentificacion: null,
        estadoCivil: null,
        regimenMatrimonial: null,
        coloniaId: 0,
        codigoPostal: null,
        gradoEstudios: null,
        profesion: null,
        regimenFiscal: null,
        giroEmpresaId: null,
        giroEmpresa: null,
        puestoId: null,
        puesto: null,
        otroPuesto: null,
        numeroDependientes: null,
        egresoMensual: null,
        tipoVivienda: null,
        tipoEmpleo: null,
        departamentoEmpleo: null,
        domicilioFiscal: null,
        ingresoId: 0,
        tipoIngreso: null,
        divisa: null,
        empresa: "",
        monto: null,
        antiguedadMeses: null,
        antiguedadAnios: null,
        utilidad: null,
        esPersonaMoral: false,
        regimenFiscalId: null,
      },
      DatosUbicacionParticular: {
        ubicacionId: null,
        paisId: null,
        estado: null,
        ciudad: null,
        codigoPostal: null,
      },
      DatosUbicacionGeneralParticular: {
        calle: null,
        numero: null,
      },
      direccion: {
        estado: null,
        ciudad: null,
      },
      direccionEmpresa: {
        ciudad: "",
        estado: "",
      },
      direccionFiscal: {
        ciudad: "",
        estado: "",
      },

      coloniaExistenteParticular: null,
      coloniaExistenteOficina: null,
      coloniaExistenteFiscal: null,

      PuntoContactoConyuge: {
        telefonoFijoConyuge: {
          puntoContactoId: 0,
          valor: null
        },
        telefonoMovilConyuge: {
          puntoContactoId: 0,
          valor: null
        },
        correoConyuge: {
          puntoContactoId: 0,
          valor: null
        }
      },

      PuntoContactoGeneral: {
        telefonoFijo: {
          puntoContactoId: 0,
          valor: null,
        },
        telefonoMovil: {
          puntoContactoId: 0,
          valor: null,
        },
        correo1: {
          puntoContactoId: 0,
          valor: null,
        },
        correo2: {
          puntoContactoId: 0,
          valor: null,
        },
        telefonoFijoOficina: {
          puntoContactoId: 0,
          valor: null,
        },
      },

      DatosUbicacionGeneralOficina: {
        ubicacionId: 0,
        prospectoId: null,
        tipoUbicacion: 1,
        calle: null,
        numero: null,
        direccionFacturacion: false,
      },
      DatosUbicacionGeneralFiscal: {
        ubicacionId: 0,
        prospectoId: null,
        tipoUbicacion: 2,
        calle: null,
        numero: null,
        direccionFacturacion: false,
      },
      DatosUbicacionOficina: {
        ubicacionId: null,
        paisId: null,
        estado: null,
        ciudad: null,
        codigoPostal: null,
      },
      DatosUbicacionFiscal: {
        ubicacionId: null,
        coloniaId: null,
      },

      PuntosContacto: [],

      DatosIngreso: {
        ingresoId: 0,
        prospectoId: null,
        tipoIngreso: null,
        divisa: null,
        empresa: "",
        giroEmpresa: "",
        puesto: "",
        monto: null,
        antiguedadMeses: null,
        antiguedadAnios: null,
        utilidad: null,
        esPersonaMoral: false,
      },

      codigoPostalOficina: null,
      paisIdOficina: null,
      EstadoOficina: null,
      CiudadOficina: null,
      codigoPostalFiscal: null,
      codigoPostalParticular: null,
      codigoPostalValido: false,
      codigoPostalValidoEmpresa: false,
      codigoPostalValidoFiscal: false,
      FormBeneficiarios: [
        {
          beneficiarioId: 0,
          solicitudId: 0,
          nombre: "",
          apellidoPaterno: "",
          apellidoMaterno: "",
          parentesco: null,
          porcentaje: null,
          telefono: null,
        },
      ],
    };
  },
  computed: {
    PasosStepper() {
      if (this.tipoPersona == 5)
        return ["General Data", "Address", "Income", "Beneficiaries"];
      return ["General Data", "Address", "Income"];
    },
    MostrarBotonFinalizar() {
      var tipo = this.tipoPersona;
      if ((tipo == 4 || tipo == 5) && this.seccionActual == 4) {
        return true;
      } else if ((tipo == 6 || tipo == 7) && this.seccionActual == 3) {
        return true;
      }
      return false;
    },   
camposVaciosBeneficiarioForm: function() {
      let llaves = Object.keys(this.FormBeneficiarios[this.FormBeneficiarios.length -1]);
      let vacios = 0;
      llaves.forEach(llave => {
        if(llave !== "apellidoMaterno" && llave !== "beneficiarioId" && llave !== "solicitudId"){
          if(llave === "parentesco")
          {         
            if(this.FormBeneficiarios[this.FormBeneficiarios.length -1][llave] === "" || this.FormBeneficiarios[this.FormBeneficiarios.length -1][llave] === null || this.FormBeneficiarios[this.FormBeneficiarios.length -1][llave] < 0){
            vacios++;
           }
          }
           else
          {
            if(this.FormBeneficiarios[this.FormBeneficiarios.length -1][llave] === "" || this.FormBeneficiarios[this.FormBeneficiarios.length -1][llave] === null || this.FormBeneficiarios[this.FormBeneficiarios.length -1][llave] < -1){
            vacios++;
          }
          }
        }
        
      });
      return vacios > 0 ? true : false;
    },
  
  },
  watch: {
    "personaFisicaFiguraAdicional.divisa": function () {
      if (this.personaFisicaFiguraAdicional.divisa == 3) {
        this.opcionesAutoNumeric = {
          currencySymbol: " €",
          decimalCharacter: ",",
          digitGroupSeparator: ".",
          currencySymbolPlacement: "p",
        };
      } else {
        this.opcionesAutoNumeric = {
          digitGroupSeparator: ",",
          decimalCharacter: ".",
          decimalCharacterAlternative: ".",
          currencySymbol: "$",
          currencySymbolPlacement: "p",
          roundingMethod: "U",
          minimumValue: "0",
          maximumValue: "15000000",
        };
      }
    },
    "personaFisicaFiguraAdicional.fechaNacimiento": function () {
      var fechaNacimiento = new Date(
        this.personaFisicaFiguraAdicional.fechaNacimiento
      );
      this.esMayorDeEdad = servicios.EsMayorDeEdad(fechaNacimiento);
    },
    "DatosUbicacionParticular.paisId": function() {
      let pais = this.catalogos.paises.find(
        t => t.paisId == this.DatosUbicacionParticular.paisId
      );
      this.CPExpresionRegularPais = pais.validacion;
    },

    FormBeneficiarios: {
      handler: function (value) {
        value.forEach(item => {
          item.porcentaje = item.porcentaje == "" ? 0 : Math.trunc(servicios.EvitarNegativos(item.porcentaje));
          item.telefono = servicios.LimitarTelefonoLocal(item.telefono);
        });
      },
      deep: true,
    },
    "DatosSolicitudGeneral.requiereFactura": function () {
      if (this.DatosSolicitudGeneral.requiereFactura == false) {
        this.DatosPersonaFisica.domicilioFiscal = null;
        this.DatosUbicacionGeneralFiscal.calle = null;
        this.DatosUbicacionGeneralFiscal.numero = null;
        this.DatosUbicacionFiscal.coloniaId = null;
        this.catalogos.coloniasFactura = [];
      }
    },
    "DatosPersonaFisica.domicilioFiscal": function () {
      if (this.DatosPersonaFisica.domicilioFiscal == "0") {
        this.DatosUbicacionGeneralParticular.direccionFacturacion = true;
        this.DatosUbicacionGeneralFiscal.direccionFacturacion = false;
      } else if (this.DatosPersonaFisica.domicilioFiscal == "1") {
        this.DatosUbicacionGeneralParticular.direccionFacturacion = false;
        this.DatosUbicacionGeneralFiscal.direccionFacturacion = true;
      }
    },
    'PuntoContactoConyuge.telefonoFijoConyuge.valor' : function() {
      this.PuntoContactoConyuge.telefonoFijoConyuge.valor = servicios.LimitarTelefonoLocal(this.PuntoContactoConyuge.telefonoFijoConyuge.valor);
    },
    'PuntoContactoConyuge.telefonoMovilConyuge.valor' : function() {
      this.PuntoContactoConyuge.telefonoMovilConyuge.valor = servicios.LimitarTelefonoLocal(this.PuntoContactoConyuge.telefonoMovilConyuge.valor);
    },
    "PuntoContactoGeneral.telefonoFijo.valor": function () {
      this.PuntoContactoGeneral.telefonoFijo.valor =
        servicios.LimitarTelefonoLocal(
          this.PuntoContactoGeneral.telefonoFijo.valor
        );
    },
    "PuntoContactoGeneral.telefonoMovil.valor": function () {
      this.PuntoContactoGeneral.telefonoMovil.valor =
        servicios.LimitarTelefonoLocal(
          this.PuntoContactoGeneral.telefonoMovil.valor
        );
    },
    "PuntoContactoGeneral.telefonoFijoOficina.valor": function () {
      this.PuntoContactoGeneral.telefonoFijoOficina.valor =
        servicios.LimitarTelefonoLocal(
          this.PuntoContactoGeneral.telefonoFijoOficina.valor
        );
    },
    "PuntoContactoGeneral.telefonoMovilOficina.valor": function () {
      this.PuntoContactoGeneral.telefonoMovilOficina.valor =
        servicios.LimitarTelefonoLocal(
          this.PuntoContactoGeneral.telefonoMovilOficina.valor
        );
    },
    // 'codigoPostalParticular' : function () {
    //   this.codigoPostalParticular = this.codigoPostalParticular.toString();
    // },
    "DatosUbicacionGeneralOficina.calle": function () {
      this.DatosUbicacionGeneralOficina.calle =
        this.DatosUbicacionGeneralOficina.calle == ""
          ? null
          : this.DatosUbicacionGeneralOficina.calle;
    },
    "DatosUbicacionGeneralOficina.numero": function () {
      this.DatosUbicacionGeneralOficina.numero =
        this.DatosUbicacionGeneralOficina.numero == ""
          ? null
          : this.DatosUbicacionGeneralOficina.numero;
    },
    "DatosReferencia.aniosRelacion": function () {
      this.DatosReferencia.aniosRelacion = servicios.EvitarNegativos(
        this.DatosReferencia.aniosRelacion
      );
      if (this.DatosReferencia.aniosRelacion > 100)
        this.DatosReferencia.aniosRelacion = 100;
    },
    "personaFisicaFiguraAdicional.antiguedadAnios": function () {
      this.personaFisicaFiguraAdicional.antiguedadAnios = servicios.EvitarNegativos(
        this.personaFisicaFiguraAdicional.antiguedadAnios
      );
      if (this.personaFisicaFiguraAdicional.antiguedadAnios > 65)
        this.personaFisicaFiguraAdicional.antiguedadAnios = 65;
    },
    "DatosIngreso.antiguedadMeses": function () {
      this.DatosIngreso.antiguedadMeses = servicios.EvitarNegativos(
        this.DatosIngreso.antiguedadMeses
      );
      if (this.DatosIngreso.antiguedadMeses > 12)
        this.DatosIngreso.antiguedadMeses = 12;
    },
    "DatosReferencia.telefonoParticular": function () {
      this.DatosReferencia.telefonoParticular = servicios.EvitarNegativos(
        this.DatosReferencia.telefonoParticular
      );
      this.DatosReferencia.telefonoParticular = servicios.LimitarTelefonoLocal(
        this.DatosReferencia.telefonoParticular
      );
    },
    "DatosReferencia.telefonoMovil": function () {
      this.DatosReferencia.telefonoMovil = servicios.EvitarNegativos(
        this.DatosReferencia.telefonoMovil
      );
      this.DatosReferencia.telefonoMovil = servicios.LimitarTelefonoLocal(
        this.DatosReferencia.telefonoMovil
      );
    },
    "personaFisicaFiguraAdicional.numeroDependientes": function () {
      this.personaFisicaFiguraAdicional.numeroDependientes =
        this.personaFisicaFiguraAdicional.numeroDependientes < 1
          ? 0
          : this.personaFisicaFiguraAdicional.numeroDependientes;
      if (this.personaFisicaFiguraAdicional.numeroDependientes > 10)
        this.personaFisicaFiguraAdicional.numeroDependientes = 10;
    },
    "DatosSolicitudGeneral.fechaNacimiento": function () {
      var fechaNacimiento = new Date(
        this.DatosSolicitudGeneral.fechaNacimiento
      );
      this.esMayorDeEdad = servicios.EsMayorDeEdad(fechaNacimiento);
    },
  },
  methods: {
    async ObtenerFiguraAdicionalId() {
      const prospecto = { params: { prospectoId: this.ProspectoId } };
      try {
        let res = await axios.get(rutaObtenerFiguraAdicionalId, prospecto);
        if (res.data.estado === 0) {
          this.personaFisicaFiguraAdicional.figuraAdicionalId = res.data.data;
        }
      } catch (e) {
        this.ManejarExcepcion(e);
      }
    },
    async CargarDatosExistentesFiguraAdicional(prospectoId) {
      const prospecto = { params: { prospectoId: prospectoId } };

      try {
        let res = await axios.get(
          rutaCargarDatosExistentesFiguraAdicional,
          prospecto
        );
        this.solicitudExistenteId = res.data.data.solicitudId;
        if (res.data.estado === 0) {
          var datos = res.data.data;
          this.LlenarDatosExistentes(datos);
        }
      } catch (e) {
        this.ManejarExcepcion(e);
      }
    },
    LlenarDatosExistentes(datosExistentes) {
      this.personaFisicaFiguraAdicional.SolicitudId = this.solicitudExistenteId;
      this.personaFisicaFiguraAdicional.EtapaId = datosExistentes.etapaId;

      if (this.personaFisicaFiguraAdicional.EtapaId > 10) {
        this.soloLectura = true;
      }

      this.PuntoContactoConyuge.correoConyuge.valor = datosExistentes.correoConyuge;
      this.PuntoContactoConyuge.telefonoFijoConyuge.valor = datosExistentes.telefonoFijoConyuge;
      this.PuntoContactoConyuge.telefonoMovilConyuge.valor = datosExistentes.telefonoMovilConyuge;
      this.personaFisicaFiguraAdicional.nombreConyuge = datosExistentes.nombreConyuge;
      this.personaFisicaFiguraAdicional.nombres = datosExistentes.nombres;
      this.personaFisicaFiguraAdicional.apellidoPaterno =
        datosExistentes.apellidoPaterno;
      this.personaFisicaFiguraAdicional.apellidoMaterno =
        datosExistentes.apellidoMaterno;
      this.PuntoContactoGeneral.telefonoMovil.valor = datosExistentes.telefono;
      this.PuntoContactoGeneral.correo1.valor =
        datosExistentes.correoElectronico;
      this.PuntoContactoGeneral.telefonoFijoOficina.valor =
        datosExistentes.telefonoFijoOficina;
      this.PuntoContactoGeneral.correo2.valor =
        datosExistentes.correoElectronicoOficina;
      this.personaFisicaFiguraAdicional.lugarNacimiento =
        datosExistentes.lugarNacimiento;
      this.personaFisicaFiguraAdicional.nacionalidad =
        datosExistentes.nacionalidad;
      this.personaFisicaFiguraAdicional.fechaNacimiento =
        datosExistentes.fechaNacimiento;
      this.personaFisicaFiguraAdicional.rfc = datosExistentes.rfc;
      this.personaFisicaFiguraAdicional.sexo = datosExistentes.sexo;
      this.personaFisicaFiguraAdicional.tipoIdentificacion =
        datosExistentes.tipoIdentificacion;
      this.personaFisicaFiguraAdicional.numeroIdentificacion =
        datosExistentes.numeroIdentificacion;
      this.personaFisicaFiguraAdicional.curp = datosExistentes.curp;
      this.personaFisicaFiguraAdicional.estadoCivil =
        datosExistentes.estadoCivil;
      this.personaFisicaFiguraAdicional.profesion = datosExistentes.profesion;
      this.personaFisicaFiguraAdicional.puestoId = datosExistentes.puestoId;
      this.personaFisicaFiguraAdicional.giroEmpresaId =
        datosExistentes.giroEmpresaId;
      this.personaFisicaFiguraAdicional.otroPuesto = datosExistentes.otroPuesto;
      this.personaFisicaFiguraAdicional.regimenFiscalId = datosExistentes.regimenFiscalId;
      this.personaFisicaFiguraAdicional.gradoEstudios =
        datosExistentes.gradoEstudios;
      this.personaFisicaFiguraAdicional.numeroDependientes =
        datosExistentes.numeroDependientes;
      this.personaFisicaFiguraAdicional.egresoMensual =
        datosExistentes.egresoMensual;
      this.personaFisicaFiguraAdicional.tipoVivienda =
        datosExistentes.tipoVivienda;
      this.personaFisicaFiguraAdicional.tipoEmpleo = datosExistentes.tipoEmpleo;
      this.personaFisicaFiguraAdicional.departamentoEmpleo =
        datosExistentes.departamentoEmpleo;
      this.personaFisicaFiguraAdicional.domicilioFiscal =
        datosExistentes.domicilioFiscal;
      this.personaFisicaFiguraAdicional.calleOficina =
        datosExistentes.calleOficina;
      this.personaFisicaFiguraAdicional.numeroOficina =
        datosExistentes.numeroOficina;
      this.personaFisicaFiguraAdicional.coloniaIdOficina =
        datosExistentes.coloniaIdOficina;
      this.personaFisicaFiguraAdicional.codigoPostalOficina =
        datosExistentes.codigoPostalOficina;
      this.codigoPostalOficina =
        this.personaFisicaFiguraAdicional.codigoPostalOficina;
      this.DatosUbicacionOficina.paisId = datosExistentes.paisIdOficina;
      this.DatosUbicacionOficina.estado = datosExistentes.estadoOficina;
      this.DatosUbicacionOficina.ciudad = datosExistentes.ciudadOficina;
      this.personaFisicaFiguraAdicional.calle = datosExistentes.calle;
      this.personaFisicaFiguraAdicional.numero = datosExistentes.numero;
      //this.personaFisicaFiguraAdicional.coloniaId = datosExistentes.coloniaId;
      this.DatosUbicacionParticular.paisId = datosExistentes.paisId;
      this.DatosUbicacionParticular.estado = datosExistentes.estado;
      this.DatosUbicacionParticular.ciudad = datosExistentes.ciudad;
      this.personaFisicaFiguraAdicional.codigoPostal =
        datosExistentes.codigoPostal;
      this.codigoPostalParticular =
        this.personaFisicaFiguraAdicional.codigoPostal;

      this.personaFisicaFiguraAdicional.regimenMatrimonial =
        datosExistentes.regimenMatrimonial;
      this.personaFisicaFiguraAdicional.ingresoId = datosExistentes.ingresoId;
      this.personaFisicaFiguraAdicional.tipoIngreso =
        datosExistentes.tipoIngreso;
      if (datosExistentes.divisa != null)
        this.personaFisicaFiguraAdicional.divisa = datosExistentes.divisa;
      this.personaFisicaFiguraAdicional.empresa = datosExistentes.empresa;
      this.personaFisicaFiguraAdicional.giroEmpresa =
        datosExistentes.giroEmpresa;
      this.personaFisicaFiguraAdicional.puesto = datosExistentes.puesto;
      this.personaFisicaFiguraAdicional.monto = datosExistentes.monto;
      this.personaFisicaFiguraAdicional.antiguedadMeses =
        datosExistentes.antiguedadMeses;
      this.personaFisicaFiguraAdicional.antiguedadAnios =
        datosExistentes.antiguedadAnios;
      this.personaFisicaFiguraAdicional.utilidad = datosExistentes.utilidad;
      this.personaFisicaFiguraAdicional.esPersonaMoral =
        datosExistentes.esPersonaMoral;

      //Redirigir a pagina 1 del cuestionario
      // if (this.tipoUsuario == 4) {
      //this.seccionActual = 1;
      // }
    },
    AnteriorSeccion() {
      if (this.seccionActual != 1) {
        this.seccionActual--;
        window.scrollTo(0, 0);
      }
    },
    SiguienteSeccion() {
      switch (this.seccionActual) {
        case 1:
          this.$refs.submitA.click();
          break;
        case 2:
          this.$refs.submitB.click();
          break;
        case 3:
          this.$refs.submitC.click();
          break;
        case 4:
          break;
      }
    },
    ValidarFormularioAntesAvanzar() {
      var formularioValido = false;
      switch (this.seccionActual) {
        case 1:
          this.seccionValidadaA = true;
          formularioValido = this.$refs.formularioA.checkValidity();
          break;
        case 2:
          this.seccionValidadaB = true;
          formularioValido = this.$refs.formularioB.checkValidity();
          break;
        case 3:
          this.seccionValidadaC = true;
          formularioValido = this.$refs.formularioC.checkValidity();
          break;
      }
      if (formularioValido) {
        if (this.seccionActual == 1) {
          // if (this.ValidarRFC() == false) {
          //   this.AlertaEmbajadores(
          //     "Por favor verifica que el formato del RFC sea válido.",
          //     true
          //   );
          //   return;
          // }
          // if (this.ValidarCURP() == false) {
          //   this.AlertaEmbajadores(
          //     "La curp ingresada: " +
          //       this.personaFisicaFiguraAdicional.curp.toUpperCase() +
          //       " no cuenta con la longitud de 18 el formato establecido 4 Letras, 6 números, 6 letras, un número o letra y un número o no coincide con la fecha ingresada",
          //     true
          //   );
          //   return;
          // }
          if (this.personaFisicaFiguraAdicional.fechaNacimiento == null) {
            this.AlertaEmbajadores(
              "Please indicate your date of birth.",
              true,
              true
            );
            return;
          } else if (!this.esMayorDeEdad) {
            this.AlertaEmbajadores(
              "You must reach the age of majority to continue the process.",
              true,
              true
            );
            return;
          } else {
            this.seccionActual++;
            window.scrollTo(0, 0);
          }
        } else if (this.seccionActual == 2) {
          this.seccionActual++;
          window.scrollTo(0, 0);

          // if (this.codigoPostalValido == false) {
          //   this.AlertaEmbajadores(
          //     "Por favor verifica que los datos de tu domicilio sean correctos.",
          //     true
          //   );
          //   return;
          //}
          //else {
          // this.seccionActual++;
          // window.scrollTo(0, 0);
          //}
        } else if (this.seccionActual == 3) {
          this.seccionActual++;
          window.scrollTo(0, 0);
        }
      }
    },
    ValidarRFC() {
      var rfcValido = true;
      //Se valida Estructura
      var regExpCHRfc =
        /^([A-ZÑ]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))([0-9-A-Z\\d]{3})?$/;
      var rfcValidadoEstructura = regExpCHRfc.test(
        this.personaFisicaFiguraAdicional.rfc
      );

      if (rfcValidadoEstructura == false) rfcValido = false;
      //Validar la fecha
      var rfcArray = "";
      rfcArray = this.personaFisicaFiguraAdicional.rfc.split("");

      var anio = rfcArray[4] + "" + rfcArray[5];
      if (anio > 19) anio = "19" + "" + anio;
      else anio = "20" + "" + anio;

      var mes = rfcArray[6] + "" + rfcArray[7];
      var dia = rfcArray[8] + "" + rfcArray[9];
      var fechaCurpRfc = anio + "-" + mes + "-" + dia;

      let indice =
        this.personaFisicaFiguraAdicional.fechaNacimiento.indexOf("T");
      let fecha = this.personaFisicaFiguraAdicional.fechaNacimiento;
      let fechaFigura = indice != -1 ? fecha.substring(0, indice) : fecha;

      if (fechaCurpRfc != fechaFigura) rfcValido = false;

      return rfcValido;
    },
    ValidarCURP() {
      var curpValido = true;
      //Se valida Estructura
      var regExpCurp =
        /[a-zA-Z]{1}[aeiouAEIOU]{1}[a-zA-Z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[hmHM]{1}(as|AS|bc|BC|bs|BS|cc|CC|cs|CS|ch|CH|cl|CL|cm|CM|df|DF|dg|DG|gt|GT|gr|GR|hg|HG|jc|JC|mc|MC|mn|MN|ms|MS|nt|NT|nl|NL|oc|OC|pl|PL|qt|QT|qr|QR|sp|SP|sl|SL|sr|SR|tc|TC|ts|TS|tl|TL|vz|VZ|yn|YN|zs|ZS|ne|NE)[0-9a-zA-Z]{3}[0-9a-zA-Z]{1}[0-9a-zA-Z]{1}$/;
      var curpValidadoEstructura = regExpCurp.test(
        this.personaFisicaFiguraAdicional.curp
      );
      if (curpValidadoEstructura == false) curpValido = false;

      //Validar la fecha
      var curpArray = "";
      curpArray = this.personaFisicaFiguraAdicional.curp.split("");

      var anio = curpArray[4] + "" + curpArray[5];
      if (anio > 19) anio = "19" + "" + anio;
      else anio = "20" + "" + anio;
      var mes = curpArray[6] + "" + curpArray[7];
      var dia = curpArray[8] + "" + curpArray[9];
      var fechaCurpRfc = anio + "-" + mes + "-" + dia;

      let indice =
        this.personaFisicaFiguraAdicional.fechaNacimiento.indexOf("T");
      let fecha = this.personaFisicaFiguraAdicional.fechaNacimiento;
      let fechaFigura = indice != -1 ? fecha.substring(0, indice) : fecha;

      if (fechaCurpRfc != fechaFigura) curpValido = false;

      return curpValido;
    },
      LimitarPorcentaje(index){
      this.FormBeneficiarios[index].porcentaje = this.FormBeneficiarios[index].porcentaje != null ? parseFloat(this.FormBeneficiarios[index].porcentaje) : 0;
      if(this.FormBeneficiarios.length == 1){
          if(this.FormBeneficiarios[0].porcentaje > 100) {
            this.FormBeneficiarios[0].porcentaje = 100;
          }
        } else {
            if(this.SumaPorcentajes() > 100){
              let resta = this.SumaPorcentajes() - this.FormBeneficiarios[index].porcentaje;
              let faltante = 100 - resta;
              this.FormBeneficiarios[index].porcentaje = faltante;
            }
        }
    },
    GuardarDatosPersonales() {
      if (this.personaFisicaFiguraAdicional.EtapaId <= 5) {
if(this.tipoPersona != 7)
{
 if(this.FormBeneficiarios.length > 0) {
            let camposVacios = 0;
            for (var beneficiario of this.FormBeneficiarios) {
              if(this.CamposActualesVacios(this.FormBeneficiarios.indexOf(beneficiario))){
                camposVacios++;
              }
            }
            if(camposVacios > 0){
              this.AlertaEmbajadores("You have not filled in all required fields in some of your beneficiaries.",true,true)
              return;
            } else {
              for(var b of this.FormBeneficiarios){
                if (b.telefono == null || b.telefono.length != 10) {
                  this.AlertaEmbajadores("The telephone number of the beneficiaries must have 10 digits.",true,true);
                  return;
                }
              }
              if(this.SumaPorcentajes() == 100) {
                this.seccionActual++;
              } else{
                this.AlertaEmbajadores("Beneficiaries must complete 100%.", true,true);
                return;
              }
            }
          } else {
            this.AlertaEmbajadores("You must enter at least one beneficiary.", true,true);
            return;
          }
}


        this.GuardarPersonaFisicaFiguraAdicional();
      } else {
        if (this.$route.params.vieneDeAdministracion != undefined) {
          if (this.esRepresentante == true)
            this.$router.push({
              name: "IntegracionExpedienteMoral",
              params: {
                prospectoId: this.ProspectoMoralId,
                vieneDeAdministracion: true,
              },
            });
          else
            this.$router.push({
              name: "IntegracionExpedienteExtranjero",
              params: {
                prospectoId: this.ProspectoId,
                vieneDeAdministracion: true,
              },
            });
        } else {
          if (this.tipoUsuario == 6 || this.tipoUsuario == 8 || this.tipoUsuario == 9 || this.tipoUsuario == 10) {
            if (this.esRepresentante == true) {
              if (this.etapaProspectoMoral == 4) {
                this.$router.push({
                  name: "IntegracionExpedienteMoral",
                  params: { prospectoId: this.ProspectoMoralId },
                });
              }
            } else {
              if (this.personaFisicaFiguraAdicional.EtapaId == 4) {
                this.$router.push({
                  name: "IntegracionExpedienteExtranjero",
                  params: { prospectoId: this.ProspectoId },
                });
              }
            }
          } else {
            this.$router.push({
              name: "IntegracionExpedienteExtranjero",
              params: { prospectoId: this.ProspectoId },
            });
          }
        }
      }
    },
    async GuardarPersonaFisicaFiguraAdicional() {
      this.personaFisicaFiguraAdicional.sexo = parseInt(
        this.personaFisicaFiguraAdicional.sexo
      );
      this.personaFisicaFiguraAdicional.tipoIdentificacion = parseInt(
        this.personaFisicaFiguraAdicional.tipoIdentificacion
      );
      this.personaFisicaFiguraAdicional.estadoCivil = parseInt(
        this.personaFisicaFiguraAdicional.estadoCivil
      );
      if (this.personaFisicaFiguraAdicional.estadoCivil == 1)
        this.personaFisicaFiguraAdicional.regimenMatrimonial = parseInt(
          this.personaFisicaFiguraAdicional.regimenMatrimonial
        );

      this.personaFisicaFiguraAdicional.correoElectronico =
        this.PuntoContactoGeneral.correo1.valor;
      this.personaFisicaFiguraAdicional.telefono =
        this.PuntoContactoGeneral.telefonoMovil.valor;

      this.personaFisicaFiguraAdicional.correoElectronicoOficina =
        this.PuntoContactoGeneral.correo2.valor;
      this.personaFisicaFiguraAdicional.telefonoFijoOficina =
        this.PuntoContactoGeneral.telefonoFijoOficina.valor;

      this.personaFisicaFiguraAdicional.correoConyuge = this.PuntoContactoConyuge.correoConyuge.valor;
      this.personaFisicaFiguraAdicional.telefonoFijoConyuge = this.PuntoContactoConyuge.telefonoFijoConyuge.valor;
      this.personaFisicaFiguraAdicional.telefonoMovilConyuge = this.PuntoContactoConyuge.telefonoMovilConyuge.valor;

      this.personaFisicaFiguraAdicional.regimenFiscalId = parseInt(
        this.personaFisicaFiguraAdicional.regimenFiscalId
      );
      this.personaFisicaFiguraAdicional.puestoId = parseInt(
        this.personaFisicaFiguraAdicional.puestoId
      );
      this.personaFisicaFiguraAdicional.giroEmpresaId = parseInt(
        this.personaFisicaFiguraAdicional.giroEmpresaId
      );

      this.personaFisicaFiguraAdicional.profesion = parseInt(
        this.personaFisicaFiguraAdicional.profesion
      );
      this.personaFisicaFiguraAdicional.gradoEstudios = parseInt(
        this.personaFisicaFiguraAdicional.gradoEstudios
      );
      this.personaFisicaFiguraAdicional.tipoVivienda = parseInt(
        this.personaFisicaFiguraAdicional.tipoVivienda
      );
      this.personaFisicaFiguraAdicional.tipoEmpleo = parseInt(
        this.personaFisicaFiguraAdicional.tipoEmpleo
      );
      this.personaFisicaFiguraAdicional.tipoIngreso = parseInt(
        this.personaFisicaFiguraAdicional.tipoIngreso
      );
      this.personaFisicaFiguraAdicional.divisa = parseInt(
        this.personaFisicaFiguraAdicional.divisa
      );

      this.personaFisicaFiguraAdicional.codigoPostal =
        this.codigoPostalParticular;
      this.personaFisicaFiguraAdicional.ciudad =
        this.DatosUbicacionParticular.ciudad;
      this.personaFisicaFiguraAdicional.estado =
        this.DatosUbicacionParticular.estado;
      this.personaFisicaFiguraAdicional.paisId = parseInt(
        this.DatosUbicacionParticular.paisId
      );

      this.personaFisicaFiguraAdicional.codigoPostalOficina =
        this.codigoPostalOficina;
      this.personaFisicaFiguraAdicional.CiudadOficina =
        this.DatosUbicacionOficina.ciudad;
      this.personaFisicaFiguraAdicional.EstadoOficina =
        this.DatosUbicacionOficina.estado;
      this.personaFisicaFiguraAdicional.PaisIdOficina = parseInt(
        this.DatosUbicacionOficina.paisId
      );

      try {
        let res = await axios.post(
          rutaGuardarPersonaFisicaFiguraAdicional,
          this.personaFisicaFiguraAdicional
        );

        this.solicitudExistenteId = res.data.data;

        this.GuardarBeneficiariosTest(this.solicitudExistenteId);

        if (res.data.estado === 0) {
          this.AlertaEmbajadores(res.data.mensaje, true,true);
        }

        if (this.$route.params.vieneDeAdministracion != undefined) {
          if (this.esRepresentante == true)
            this.$router.push({
              name: "IntegracionExpedienteMoral",
              params: {
                prospectoId: this.ProspectoMoralId,
                vieneDeAdministracion: true,
              },
            });
          else
            this.$router.push({
              name: "IntegracionExpedienteExtranjero",
              params: {
                prospectoId: this.ProspectoId,
                vieneDeAdministracion: true,
              },
            });
        } else {
          if (this.tipoUsuario == 6 || this.tipoUsuario == 8 || this.tipoUsuario == 9 || this.tipoUsuario == 10) {
            if (this.esRepresentante == true) {
              if (this.etapaProspectoMoral == 4) {
                this.$router.push({
                  name: "IntegracionExpedienteMoral",
                  params: { prospectoId: this.ProspectoMoralId },
                });
              } else {
                this.$router.push({ name: "PreAutorizacion" });
              }
            } else {
              if (this.personaFisicaFiguraAdicional.EtapaId == 4) {
                this.$router.push({
                  name: "IntegracionExpedienteExtranjero",
                  params: { prospectoId: this.ProspectoId },
                });
              } else {
                this.$router.push({ name: "PreAutorizacion" });
              }
            }
          } else {
            if (this.tipoUsuario == 4) {
              this.$router.push({ name: "PreAutorizacion" });
            } else {
              this.$router.push({
                name: "IntegracionExpedienteExtranjero",
                params: { prospectoId: this.ProspectoId },
              });
            }
          }
        }
      } catch (e) {
        this.ManejarExcepcion(e);
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";
.datos-personales-fa {
  flex-grow: 1;
}
</style>
